<div *ngIf="agent">
  <lms-breadcrumb [label]="agent.fullName || agent.email"></lms-breadcrumb>

  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="tabsManager.setTab($event)"
  >
    <mat-tab label="data">
      <ng-template mat-tab-label>{{ 'nouns.data' | translate }}</ng-template>
      <ng-template matTabContent>
        <ac-administrators-editor
          *ngIf="tooltips"
          action="edit"
          [adminData]="agent"
          [tooltips]="tooltips"
          (save)="onUpdateAgent($event)"
        ></ac-administrators-editor>
      </ng-template>
    </mat-tab>
    <mat-tab label="clients" *ngIf="config.clients">
      <ng-template mat-tab-label>{{ 'clients.label' | translate }}</ng-template>
      <ng-template matTabContent>
        <ac-clients
          [storageKey]="'agent_clients_list'"
          [canCreate]="false"
          [filters]="{ agentIds: agent.id }"
          lmsClickLink
          lmsClickRow="clients"
        ></ac-clients>
      </ng-template>
    </mat-tab>
    <mat-tab label="classes" *ngIf="config.groups">
      <ng-template mat-tab-label>{{ 'agents.tabs.groups' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-toolbar
          [options]="{ list: { listId: agentGroupslistId, download: true, filterRow: true, skeletor: true } }"
        >
          <div class="lms-toolbar__item" *lmsProfileGuard="'groups.create'" tools-actions>
            <gl-button
              color-primary
              [text]="'groups.add' | translate"
              [routerLink]="['/groups/new']"
              title="{{ 'groups.create' | translate }}"
            >
            </gl-button>
          </div>
        </lms-toolbar>
        <lms-groups-list
          [listId]="agentGroupslistId"
          [options]="{ filters: { agentIds: agent.id }, sort: 'endDate' }"
        ></lms-groups-list>
      </ng-template>
    </mat-tab>
    <mat-tab label="emails">
      <ng-template mat-tab-label>{{ 'emails.label' | translate }}</ng-template>
      <ng-template matTabContent>
        <ac-accounts-notifications [entityId]="agent.id"></ac-accounts-notifications>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="gl-context-menu__position">
    <ac-administrators-detail-actions
      [adminData]="agent"
      (deleted)="onDeleted()"
      (roleChanged)="onRoleChanged($event)"
    ></ac-administrators-detail-actions>
  </div>
</div>
